import { withProps } from 'recompose'
import badaPropsChange from './BadaProps'
import wizardChange from './Wizard'

const reducer = withProps(
  ({
    storesByAddressData: { searchOpenAuthStoresByAddress },
    StoreWithDistance,
    sbmBookingsByStoreId,
    msBookingsByStoreId,
    selectedStore,
    selectedService,
    selectedSlot,
    bookingCompleted,
    prepCompleted,
    selectedAddress,
    retrieveAddress,
    overrideMeetingType,
    pageContentServices,
  }) => ({
    wizard: wizardChange({
      selectedStore,
      selectedService,
      selectedSlot,
      bookingCompleted,
      prepCompleted,
      sbmBookingsByStoreId,
      msBookingsByStoreId,
      pageContentServices,
    }),
    badaProps: badaPropsChange({
      searchOpenAuthStoresByAddress,
      StoreWithDistance,
      sbmBookingsByStoreId,
      msBookingsByStoreId,
      overrideMeetingType,
    }),
    selectedCity: !retrieveAddress
      ? selectedAddress && selectedAddress.city // if postcode anywhere cannot deliver any address then set ipstack city name as selectedCity
      : retrieveAddress && retrieveAddress.city, // set selectedCity to response from postcode anywhere
  })
)

export default reducer
